const images = {
  yardDebris: require('../styles/icons/jobcategories/yard-debris.png'),
  yardDebrisSelected: require('../styles/icons/jobcategories/yard-debris-active.png'),

  quickHaul: require('../styles/icons/jobcategories/quick-haul.png'),
  quickHaulSelected: require('../styles/icons/jobcategories/quick-haul-active.png'),

  junk: require('../styles/icons/jobcategories/junk.png'),
  junkSelected: require('../styles/icons/jobcategories/junk-active.png'),

  recycle: require('../styles/icons/jobcategories/recycle.png'),
  recycleSelected: require('../styles/icons/jobcategories/recycle-active.png'),

  toolbarLogo: require('../styles/icons/logo/toolbar-logo.png'),
  pickupLocation: require('../styles/icons/pickuplocation/pickup-location.png'),
  calendar: require('../styles/icons/dateTime/calendar.png'),

  bigBag: require('../styles/icons/bags/big.png'),
  smallBag: require('../styles/icons/bags/small.png'),

  avatar2: require('../styles/icons/avatar/avatar2.png'),
  accepted: require('../styles/icons/emojies/accepted-emoji.gif'),
  acceptedNonActive: require('../styles/icons/emojies/accepted-nonactive-emoji.png'),
  arrived: require('../styles/icons/emojies/arrived-emoji.gif'),
  arrivedNonActive: require('../styles/icons/emojies/arrived-nonactive-emoji.png'),
  completed: require('../styles/icons/emojies/completed-emoji.gif'),
  haulerBidAccepted: require('../styles/icons/emojies/HaulerBidAccepted.gif'),
  jobDoneDisabled: require('../styles/icons/emojies/JobDoneDisabled.png'),
  onMyWay: require('../styles/icons/emojies/on-my-way-emoji.gif'),
  onMyWayNonActive: require('../styles/icons/emojies/on-my-way-nonactive-emoji.png'),
  waiting: require('../styles/icons/emojies/waiting-emoji.gif'),
  completedJobReverse: require('../styles/icons/sidemenu/completed-jobs-reverse.png'),
  bid: require('../styles/icons/tabs/jobstab-bid.png'),
  bidHasEntries: require('../styles/icons/tabs/jobstab-bid-hasentries.png'),
  currentLocation: require('../styles/icons/current-location.png'),
  notHazardous: require('../styles/icons/icon/not-hazardous.png'),
  hourGlass: require('../styles/icons/emojies/hourglass.gif'),
  myLocation: require('../styles/icons/my-location.png'),
  additionalItem: require('../styles/icons/additional-item.png'),
  plus: require('../styles/icons/plus.png'),
  magnifyingGlass: require('../styles/icons/emojies/magnifying-glass.png'),
  choice: require('../styles/icons/choice/choice.png'),
  thumbUp: require('../styles/icons/emojies/thumb-up.png'),
  thumbUpNonActive: require('../styles/icons/emojies/thumb-up-nonactive.png'),
  truck: require('../styles/icons/emojies/truck.png'),
  truckNonActive: require('../styles/icons/emojies/truck-nonactive.png'),
  securePaymentFull: require('../styles/icons/guaranteed-safe-updated.png'),
  securePaymentShrinked: require('../styles/icons/guaranteed-safe-updated-small.png'),
  splashBackground: require('../styles/icons/splash/splash-background.jpg'),
  chatIconNewMessages: require('../styles/icons/chat/chat-icon-new-messages.png'),
  chatIcon: require('../styles/icons/chat/chat-icon-black.png'),
  waitingHauler: require('../styles/icons/emojies/waiting-hauler.png')
}

export default images



// WEBPACK FOOTER //
// ./src/images/index.tsx